import { createContext, useContext, useState, useCallback, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const defaultContext = {
  updateOpenWidgetDataForRemote: () => {},
  updateOpenWidgetDataForCallingWindow: () => {},
  processRemoteOpenWidgetData: () => null,
  processCallingWindowOpenWidgetData: () => null
};
const OpenWidgetDataContext = /*#__PURE__*/createContext(defaultContext);
export function OpenWidgetDataContextProvider({
  children
}) {
  const [remoteOpenWidgetData, setRemoteOpenWidgetData] = useState(null);
  const [callingWindowOpenWidgetData, setCallingWindowOpenWidgetData] = useState(null);
  const updateOpenWidgetDataForRemote = useCallback(data => {
    setRemoteOpenWidgetData(data);
  }, []);
  const updateOpenWidgetDataForCallingWindow = useCallback(data => {
    setCallingWindowOpenWidgetData(data);
  }, []);
  const processRemoteOpenWidgetData = useCallback(() => {
    const currentData = remoteOpenWidgetData;
    setRemoteOpenWidgetData(null);
    return currentData;
  }, [remoteOpenWidgetData]);
  const processCallingWindowOpenWidgetData = useCallback(() => {
    const currentData = callingWindowOpenWidgetData;
    setCallingWindowOpenWidgetData(null);
    return currentData;
  }, [callingWindowOpenWidgetData]);
  const contextValue = useMemo(() => ({
    updateOpenWidgetDataForRemote,
    updateOpenWidgetDataForCallingWindow,
    processRemoteOpenWidgetData,
    processCallingWindowOpenWidgetData
  }), [updateOpenWidgetDataForRemote, updateOpenWidgetDataForCallingWindow, processRemoteOpenWidgetData, processCallingWindowOpenWidgetData]);
  return /*#__PURE__*/_jsx(OpenWidgetDataContext.Provider, {
    value: contextValue,
    children: children
  });
}
export function useOpenWidgetDataContext() {
  const context = useContext(OpenWidgetDataContext);
  if (context === defaultContext) {
    throw new Error('useOpenWidgetDataContext must be used within an OpenWidgetDataContextProvider');
  }
  return context;
}